/*
 * df-strip-emojis.js
 *
 * Limpia emojis de los textos visibles del menú de navegación (header desktop +
 * drawer móvil + footer). La data en Shopify admin se mantiene intacta — solo
 * cambia la presentación.
 *
 * Razón: el menú con emojis (💐Mamá, 🎁Papá) carga informalidad. Quitarlos sube
 * la percepción editorial sin tener que editar cada menú en el admin.
 *
 * Cobertura del regex: ranges Unicode de emojis (símbolos, pictogramas,
 * variation selectors, ZWJ sequences, etc.).
 */
(function () {
  'use strict';

  // Regex que cubre la mayoría de emojis modernos:
  //   - Emoticons (1F600–1F64F)
  //   - Miscellaneous Symbols and Pictographs (1F300–1F5FF)
  //   - Transport and Map (1F680–1F6FF)
  //   - Supplemental Symbols and Pictographs (1F900–1F9FF)
  //   - Symbols and Pictographs Extended-A (1FA70–1FAFF)
  //   - Misc Symbols (2600–26FF) y Dingbats (2700–27BF)
  //   - Variation Selectors (FE00–FE0F) y ZWJ (200D)
  var EMOJI_RE = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{1FA70}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F1E6}-\u{1F1FF}\u{1F000}-\u{1F0FF}\u{2300}-\u{23FF}\u{2B00}-\u{2BFF}\u{200D}]/gu;

  var TARGET_SELECTORS = [
    '.df-header__link',
    '.df-header__menu a',
    '.df-mobile-drawer__link',
    '.df-footer__col-link'
  ].join(',');

  function stripEmojisFromNode(el) {
    if (!el || el.nodeType !== 1) return;
    // Solo modificamos el texto directo del nodo, no hijos con markup (íconos SVG).
    el.childNodes.forEach(function (child) {
      if (child.nodeType === 3) { // TEXT_NODE
        var original = child.nodeValue;
        var cleaned = original.replace(EMOJI_RE, '').replace(/\s+/g, ' ').trim();
        if (cleaned !== original.trim()) {
          child.nodeValue = cleaned + (original.match(/\s+$/) ? ' ' : '');
        }
      }
    });
  }

  function run() {
    var nodes = document.querySelectorAll(TARGET_SELECTORS);
    for (var i = 0; i < nodes.length; i++) stripEmojisFromNode(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run cuando el drawer móvil se abre (links pueden renderizarse late).
  setTimeout(run, 800);
})();
